import type { VoucherIssuedForCampaignListByHotelIdAndVoucherId_DetailsPageQuery } from "@/lib/gql/__generated__/graphql";

import { useMarkVoucherAsUnUsedMutation } from "../../../repository/existing/mutation/mark-voucher-as-unused/use-mark-voucher-as-unused-mutation";
import { useMarkVoucherAsUsedMutation } from "../../../repository/existing/mutation/mark-voucher-as-used/use-mark-voucher-as-used-mutation";

type Props = {
	campaignID: string;
	serverModel: VoucherIssuedForCampaignListByHotelIdAndVoucherId_DetailsPageQuery;
};

export const useInitialized = ({ campaignID, serverModel }: Props) => {
	const { onUpdateMarkVoucherAsUnUsed } = useMarkVoucherAsUnUsedMutation({ voucherID: campaignID });
	const { onUpdateMarkVoucherAsUsed } = useMarkVoucherAsUsedMutation({ voucherID: campaignID });

	return {
		data: serverModel,
		onUpdateMarkVoucherAsUnUsed,
		onUpdateMarkVoucherAsUsed,
	};
};
